module.exports = __webpack_public_path__ + "img/mov.7e0176c4.png";